export const sectionMap = {
  main: 'product',
  properties: 'productProperties',
  reviews: 'productReviews',
  statistics: 'productPriceHistory',
} as const;

export const sectionClassicParam = {
  main: 'p',
  properties: 'e',
  reviews: 'o',
  statistics: 'pu',
} as const;
